import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";

const { Types, Creators } = createActions(
  {
    success: ["data"],
    reset: [],
  },
  { prefix: "FILTER_PICKINGS_" }
);

export interface FilterPickingsState {
  data: any | null;
}

interface SuccessFilterPickings {
  data: any;
}

const INITIAL_STATE: FilterPickingsState = {
  data: null,
};

const success = (state: FilterPickingsState, action: SuccessFilterPickings) =>
  update(state, {
    data: { $set: action.data },
  });

const reset = () => INITIAL_STATE;

export const filterPickings = createReducer(INITIAL_STATE, {
  [Types.SUCCESS]: success,
  [Types.RESET]: reset,
});

export const FilterPickingsTypes = Types;
export const FilterPickingsActions = Creators;
